module.exports = __webpack_public_path__ + "img/apple.3c4b7d8d.png";